import get from '../../../helpers/data_layer/get';
import {
  wrapResponseInPromise,
  fetchData,
} from '../../../helpers/base_data_fetcher';

const getAllStaticData = () => {
  const staticData = {
    affiliate: get('affiliate'),
    miscellaneous: get('commerce.miscellaneous'),
    customer: get('customer'),
    session: get('session'),
    site: get('site'),
    features: get('config.features'),
    page: get('page')
  };
  return wrapResponseInPromise(staticData, true);
};

export default {
  getAllStaticData,
  getAllProducts: () => fetchData('commerce.products'),
  getAllProviders: () => fetchData('commerce.payment_providers'),
  getDiscounts: () => fetchData('commerce.discounts'),
  getCart: () => fetchData('commerce.checkout_cart'),
  getContext: () => fetchData('commerce.context'),
  getPage: () => fetchData('page'),
  getExperiments: () => fetchData('experiments'),
  getLocalisations: () => fetchData('localisations')
};
